<div class="atn-assistant-loader">
  <!-- User message placeholder -->
  <div
    class="atn-assistant-loader__message atn-assistant-loader__message--outbound"
  >
    <div class="atn-assistant-loader__content">
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--medium"
      ></div>
    </div>
  </div>

  <!-- Assistant response placeholder -->
  <div
    class="atn-assistant-loader__message atn-assistant-loader__message--inbound"
  >
    <div class="atn-assistant-loader__content">
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--long"
      ></div>
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--medium"
      ></div>
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--long"
      ></div>
    </div>
  </div>

  <!-- Another user message placeholder -->
  <div
    class="atn-assistant-loader__message atn-assistant-loader__message--outbound"
  >
    <div class="atn-assistant-loader__content">
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--short"
      ></div>
    </div>
  </div>

  <!-- Another assistant response placeholder -->
  <div
    class="atn-assistant-loader__message atn-assistant-loader__message--inbound"
  >
    <div class="atn-assistant-loader__content">
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--long"
      ></div>
      <div
        class="atn-assistant-loader__line atn-assistant-loader__line--medium"
      ></div>
    </div>
  </div>
</div>
